import * as THREE from 'three'

/** 在 CPU 抵消正交视深度的公共基准，保持屏幕投影和硬件深度，不修改导航相机。 */
export function createOrthographicRenderCamera(
  camera: THREE.OrthographicCamera
): THREE.OrthographicCamera {
  const renderCamera = camera.clone()
  const depthOrigin = camera.near + (camera.far - camera.near) * 0.5
  if (!Number.isFinite(depthOrigin)) {
    return renderCamera
  }

  renderCamera.matrixWorldInverse.premultiply(
    new THREE.Matrix4().makeTranslation(0, 0, depthOrigin)
  )
  renderCamera.matrixWorld.copy(renderCamera.matrixWorldInverse).invert()
  renderCamera.matrixWorld.decompose(
    renderCamera.position,
    renderCamera.quaternion,
    renderCamera.scale
  )
  renderCamera.matrix.copy(renderCamera.matrixWorld)
  renderCamera.matrixAutoUpdate = false
  renderCamera.matrixWorldAutoUpdate = false
  renderCamera.near = camera.near - depthOrigin
  renderCamera.far = camera.far - depthOrigin
  renderCamera.projectionMatrix.multiply(new THREE.Matrix4().makeTranslation(0, 0, -depthOrigin))
  renderCamera.projectionMatrixInverse.copy(renderCamera.projectionMatrix).invert()
  return renderCamera
}
